interface CoverImageProps {
  imageUrl: string;
}
export default function CoverImage({ imageUrl }: CoverImageProps) {
  return (
    <div className="image-container">
      <img className="cover-image" alt="example" src={imageUrl} />
    </div>
  );
}
